import { Component, ChangeDetectorRef, OnDestroy, HostListener } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { inOutFade, inOutFromBottom } from './animations';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';

import { Network } from '@ionic-native/network/ngx';
import { NetworkService } from './network.service';
import { StatusBar } from '@capacitor/status-bar';
import { StatusbarService } from './utils/statusbar/statusbar.service';
import { AppService } from './app.service';

import { FCM } from '@ionic-native/fcm';   // Importar libreria FCM para notificaciones
import { Globals } from './globals';

@Component({
   selector: 'app-root',
   templateUrl: 'app.component.html',
   styleUrls: ['app.component.scss'],
   animations: [ inOutFade, inOutFromBottom ]

})
export class AppComponent  {

   devideHeight = localStorage.getItem('deviceHeight');

   menu: boolean = false;

   mostrar: number = 0;
   pathActual: string = '/';
   v_nemocabecera: string = 'home';

   isConnected: boolean = false;


   constructor(
      private platform: Platform,
      private network: NetworkService,
      private statusbar: StatusbarService,
      private serviceApp: AppService,
      private screenOrientation: ScreenOrientation,

   ) {
      this.initializeApp();
   }


   initializeApp() {

      // localStorage.setItem('refresh_token', '5JTx6s8jmf9nFHA0y6Nc');



      if(this.platform.is('cordova')){
         this.platform.ready().then(() => {
            this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
         });
      }

      this.statusbar.setTextLight();
      this.statusbar.setBackgroundColor('#FFFFFF');


      this.network.getNetworkStatus().subscribe((connected: boolean) => {
         this.isConnected = connected;
         if (!this.isConnected) {
               // console.log('Por favor enciende tu conexión a Internet');
         } else{
            // console.log('estasconSevctado!!');
         }
      });
   }


   menuOpened() {
      this.menu = true;
   }
   menuClosed() {
      this.menu = false;
   }
}
